var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data && _vm.langs
    ? _c("div", { attrs: { id: "footer" } }, [
        _c("footer", { staticClass: "footer-bg" }, [
          _vm.env === "dev" || _vm.env === "qa"
            ? _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.language,
                      expression: "language"
                    }
                  ],
                  staticClass: "form-control right",
                  class: !_vm.isPhone ? "language-select" : "",
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.language = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      function($event) {
                        return _vm.$router.replace({ query: null })
                      }
                    ]
                  }
                },
                _vm._l(_vm.langs.misc.languagelist, function(code, lang) {
                  return _c(
                    "option",
                    { key: code, domProps: { value: code } },
                    [_vm._v("\n        🌎 " + _vm._s(lang) + "\n      ")]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isPhone ? _c("div", { staticClass: "clearfix" }) : _vm._e(),
          _vm._v(" "),
          _c("a", { attrs: { href: "/" } }, [
            _c("img", {
              staticClass: "img-footer left",
              attrs: {
                src: require("../assets/img/novonordisk.png"),
                alt: "Novo Nordisk Logotyp"
              }
            })
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "footer-text",
            domProps: { innerHTML: _vm._s(_vm.data.misc.bottomDisclaimer) }
          })
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0959a4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0959a4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bottom.vue
// module id = null
// module chunks = 